export const isEffect = `() => {
    const isCookiesExists = getCookie({ keyname: "session_id" });
    useEffect(() => {
        if (!isCookiesExists) {
            setCookie({ keyname: "session_id", keyvalue: uuidv4(), minutes: 30 });
            setOpen(!isOpen)
            initializeTracking({
                "types": "page_view",
                "link_label": "Download Indomaret",
                "pageName": "/claim-prized",
                "url": "https://us-central1-idm-klik-dev.cloudfunctions.net/klikidm_apps_tracker_gateway",
                "reqParams": {
                  "Content-Type": "application/json"
                }
              });
        }
    }, [isCookiesExists])
}`

export const ClickView = `() => {
    return (
        <button
            onClick={initializeTracking({
                "custom_core_data": {
                  "event_name": "page_view",
                  "event_timestamp": "1654589080",
                  "page_name": "tes",
                  "page_urlpath": "http:tes.com",
                  "previous_page": "Home",
                  "previous_page_urlpath": ""
                },
                "custom_user_data": {
                  "session_id": "7d32c247-b8aa-4c35-bfc9-98062ddcff81-1632455965352",
                  "user_id": "999"
                },
                "custom_application_data": {
                  "source_name": "web",
                  "os_name": "Windows",
                  "os_version": "Windows version",
                  "browser_name": "Chrome 95"
                },
                "custom_marketing_data": {
                  "utm_raw": "https://www.klikindomaret.com/product/body-scent-spray-cologne?utm_source=facebook&utm_medium=banner&utm_campaign=product_kecantikan_20220323&utm_id=12345&utm_term=running&utm_content=product_kecantikan"
                },
                "url": "https://us-central1-idm-klik-dev.cloudfunctions.net/klikidm_apps_tracker_gateway",
                "reqParams": {
                  "Content-Type": "application/json"
                }
              })}>Click Link!!
        </button>
    )
}`

export const previewLiveTracker = ` initializeTracking({
    types: "click_view_web",
    link_label: null,
    pageName: "home",
    custom_core_data: {
        previousPage: "links",
        previousURL: "isURLComing"
    },
    url: "/api/tracker",
    reqParams: {
        "x-api-key": "AIzaSyAupTMnsywgUeZh0QAVf68DdK4fAdpiTv8",//or "Authorization": "AIzaSyAupTMnsywgUeZh0QAVf68DdK4fAdpiTv8
        'Content-Type': 'application/json',
    },
})`
export const isCustomResources = `() => initializeTracking({
    newSources: {
        "core": {
            "event_name": "page_view",
            "event_timestamp": "1654589080",
            "page_name": "tes", "page_urlpath": "http:tes.com",
            "previous_page": "Home",
            "previous_page_urlpath": ""
        },
        "user": {
            "session_id": "7d32c247-b8aa-4c35-bfc9-98062ddcff81-1632455965352",
            "user_id": "999"
        },
        "application": {
            "source_name": "web",
            "os_name": "Windows",
            "os_version": "Windows version",
            "browser_name": "Chrome 95"
        },
        "marketing": {
            "utm_raw": "https://www.klikindomaret.com/product/body-scent-spray-cologne?utm_source=facebook&utm_medium=banner&utm_campaign=product_kecantikan_20220323&utm_id=12345&utm_term=running&utm_content=product_kecantikan"
        }
    },
    url: "https://klikidm-apps-tracker-gateway-45cx4ebp.uc.gateway.dev/apps-tracker-gateway",
    reqParams: {
        'Content-Type': 'application/json',
    }
})`

export const jsonCode = `{
    "data": [{
        "core": {
            "event_name": "page_view",
            "event_timestamp": "1654589080",
            "page_name": "tes", "page_urlpath": "http:tes.com",
            "previous_page": "Home",
            "previous_page_urlpath": ""
        },
        "user": {
            "session_id": "7d32c247-b8aa-4c35-bfc9-98062ddcff81-1632455965352",
            "user_id": "999"
        },
        "application": {
            "source_name": "web",
            "os_name": "Windows",
            "os_version": "Windows version",
            "browser_name": "Chrome 95"
        },
        "marketing": {
            "utm_raw": "https://www.klikindomaret.com/product/body-scent-spray-cologne?utm_source=facebook&utm_medium=banner&utm_campaign=product_kecantikan_20220323&utm_id=12345&utm_term=running&utm_content=product_kecantikan"
        }
    }]
}`


export const isJqueryOnload = `$(document).ready(function() {
    const{initializeTracking} = window.tracker
    initializeTracking({
        "types": "page_view",
        "link_label": "Download Indomaret",
        "pageName": "/claim-prized",
        "url": "https://us-central1-idm-klik-dev.cloudfunctions.net/klikidm_apps_tracker_gateway",
        "reqParams": {
            "Content-Type": "application/json"
        }
    }).then(res => console.log(res)).catch(err => console.log(err))
});`

export const isJqueryOnClick = `$(document).ready(function() {
    $("#button").on("click",function() {
        const{ initializeTracking } = window.tracker
        initializeTracking({
            "custom_core_data": {
                "event_name": "page_view",
                "event_timestamp": "1654589080",
                "page_name": "tes",
                "page_urlpath": "http:tes.com",
                "previous_page": "Home",
                "previous_page_urlpath": ""
            },
            "custom_user_data": {
                "session_id": "7d32c247-b8aa-4c35-bfc9-98062ddcff81-1632455965352",
                "user_id": "999"
            },
            "custom_application_data": {
                "source_name": "web",
                "os_name": "Windows",
                "os_version": "Windows version",
                "browser_name": "Chrome 95"
            },
            "custom_marketing_data": {
                "utm_raw": "https://www.klikindomaret.com/product/body-scent-spray-cologne?utm_source=facebook&utm_medium=banner&utm_campaign=product_kecantikan_20220323&utm_id=12345&utm_term=running&utm_content=product_kecantikan"
            },
            "url": "https://us-central1-idm-klik-dev.cloudfunctions.net/klikidm_apps_tracker_gateway",
            "reqParams": {
                "Content-Type": "application/json"
            }
          }).then(res => console.log(res)).catch(err => console.log(err))
    });
});`

export const isJqueryNewResources = `$(document).ready(function() {
    $("#button").on("click",function() {
        const{ initializeTracking } = window.tracker
        initializeTracking({
            "newSources": {
                "core": {
                    "event_name": "page_view",
                    "event_timestamp": "1654589080",
                    "page_name": "tes",
                    "page_urlpath": "http:tes.com",
                    "previous_page": "Home",
                    "previous_page_urlpath": ""
                },
                "user": {
                    "session_id": "7d32c247-b8aa-4c35-bfc9-98062ddcff81-1632455965352",
                    "user_id": "999"
                },
                "application": {
                    "source_name": "web",
                    "os_name": "Windows",
                    "os_version": "Windows version",
                    "browser_name": "Chrome 95",
                    "device_id": "edts-print"
                },
                "marketing": {
                    "utm_raw": "https://www.klikindomaret.com/product/body-scent-spray-cologne?utm_source=facebook&utm_medium=banner&utm_campaign=product_kecantikan_20220323&utm_id=12345&utm_term=running&utm_content=product_kecantikan"
                }
            },
            "url": "https://us-central1-idm-klik-dev.cloudfunctions.net/klikidm_apps_tracker_gateway",
            "reqParams": {
                "Content-Type": "application/json"
            }
        }).then(res => console.log(res)).catch(err => console.log(err))
    });
});`